import { UseFormMethods } from 'react-hook-form';
import { getObjectProperty } from 'modules/core/utils';

const getDirtyFieldPaths = (obj: Record<string, any>, prefix: string = ''): string[] =>
  Object.entries(obj).flatMap(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;

    if (value === true) return [path];

    if (typeof value === 'object' && value !== null) {
      return getDirtyFieldPaths(value, path);
    }

    return [];
  });

const isEmptyField = (value: any): boolean =>
  value === null || value === undefined || Number.isNaN(value) || value === 0 || value === '';

export const getNormalizedDirty = (
  formMethods: UseFormMethods<any>,
  defaultValues: Record<string, any>,
  prefix?: string,
) => {
  const {
    getValues,
    formState: { isDirty, dirtyFields },
  } = formMethods;

  const actualDirtyFields = prefix ? dirtyFields?.[prefix] : dirtyFields;

  if (!isDirty || Object.keys(actualDirtyFields || {}).length === 0) return false;

  const values = getValues();
  const actualValues = prefix ? values?.[prefix] : values;
  const dirtyFieldPaths = getDirtyFieldPaths(actualDirtyFields);

  return dirtyFieldPaths.some((path: string) => {
    const defaultValue = getObjectProperty(defaultValues, path);
    const currentValue = getObjectProperty(actualValues, path);

    return isEmptyField(defaultValue) && isEmptyField(currentValue) ? false : defaultValue !== currentValue;
  });
};
